import React from 'react'
import { View, type ViewStyle } from 'react-native'
import Svg, { Path } from 'react-native-svg'

interface ExchangeIconProps {
  width?: number
  height?: number
  color?: string
  style?: ViewStyle
}

const ExchangeIcon: React.FC<ExchangeIconProps> = ({
  width = 32,
  height = 32,
  color = 'white',
  style,
}) => (
  <View style={style}>
    <Svg width={width} height={height} viewBox="0 0 32 32" fill="none">
      <Path
        d="M5.3335 10.4377H25.3335M22.8956 6.6665L25.724 9.49493C26.2447 10.0156 26.2447 10.8598 25.724 11.3805L22.8956 14.209M26.6668 21.1044L6.66683 21.1044M9.10473 24.8756L6.27631 22.0472C5.75561 21.5265 5.75561 20.6823 6.27631 20.1616L9.10473 17.3332"
        stroke={color}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  </View>
)

export default ExchangeIcon
